import { deleteClient } from "@/business/clients/application/deleteClient";
import { getAllClients } from "@/business/clients/application/getAllClients";
import { getClientById } from "@/business/clients/application/getClientById";
import { Client } from "@/business/clients/domain/clients";
import { onMounted, ref, Ref, computed } from "vue";
import { useRouter } from "vue-router";

export function clientsUse() {
  const router = useRouter();
  const clients: Ref<Client[]> = ref([]);
  const query: Ref<string> = ref("");
  const clientSelected: Ref<Client | null> = ref(null);

  onMounted(async () => {
    await getClientsFromApi();
  });

  async function createClientOption() {
    await router.push("/administrator/client");
  }

  async function getClientsFromApi(): Promise<void> {
    clients.value = await getAllClients.execute();
  }

  const filteredClients = computed(() => {
    let result = clients.value;
    if (query.value.length > 0) {
      result = clients.value.filter((client) =>
        client.company.toLowerCase().includes(query.value.toLowerCase())
      );
    }
    return result;
  });

  async function editClientOption(clientId: string): Promise<void> {
    await getClientById.execute(clientId);
    await router.push("/artist/artwork/".concat(clientId));
  }

  async function deleteTheClient(): Promise<void> {
    await deleteClient.execute(clientSelected.value?.clientId ?? "");
  }


  return {
    createClientOption,
    query,
    clients,
    filteredClients,
    editClientOption,
    deleteTheClient,
    clientSelected,
  };
}
